export default __webpack_public_path__ + "static/media/drone11.8848f8ae.jpg";